module.exports = __webpack_public_path__ + "static/img/Ico_circle_exclamation.4d8c85e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Ico_circle_exclamation.png
// module id = Avm4
// module chunks = 1